"use client";

import { ContentComponent } from "@/types/modules";
import Content from "../Content";
import Featured from "../Featured";
import ViewAll from "../ViewAll";
import { LanguageContext } from "@/context/languageContext";
import { useContext, useEffect } from "react";
import { Voucher } from "@/types/wordpress";
import { translate } from "@/utils/translate";
import { useLanguageUrl } from "@/context/languageURLContext";

interface VoucherComponentProps {
  voucher: Voucher;
}

export default function VoucherComponent({ voucher }: VoucherComponentProps) {
  const { language } = useContext(LanguageContext);

  const { url, setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(voucher.translations[0].uri);
  }, [setUrl, voucher.translations]);

  const content: ContentComponent = {
    imageAlign: voucher.contentFields.imageAlign,
    textAlign: voucher.contentFields.textAlign,
    content: voucher.contentFields.body,
    gallery: voucher.contentFields.gallery,
    sameWidth: true,
    ...(voucher.contentFields.button
      ? {
          button: voucher.contentFields.button,
        }
      : {
          buttonVouchers: {
            text: translate["enquireNow"][language],
          },
        }),
    ...(voucher.contentFields.title && {
      title: voucher.contentFields.title,
    }),
  };

  return (
    <>
      <section className="content">
        <div className="contentContainer contentVouchers">
          <Content content={content} />
        </div>
      </section>
      <ViewAll
        text={translate["viewAllVouchers"][language]}
        link={`/${language}/vouchers`}
      />
      <Featured featured={voucher.featured} />
    </>
  );
}
